// 认证状态
export const AuthenticationConfig = {
    '1': { color: 'gray', text: '未认证' },
    '2': { color: 'warning', text: '审核中' },
    '3': { color: 'success', text: '认证成功' },
    '4': { color: 'danger', text: '审核失败' }
}